const ArrowDown = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="icon-arrow-down"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path
        fill-rule="evenodd"
        clipRule="evenodd"
        d="M6.99979 9C6.80204 9.00004 6.60874 9.05871 6.44433 9.1686C6.27992 9.27848 6.15178 9.43465 6.07611 9.61735C6.00044 9.80005 5.98064 10.0011 6.0192 10.195C6.05777 10.389 6.15298 10.5671 6.29279 10.707L11.2928 15.707C11.4803 15.8945 11.7346 15.9998 11.9998 15.9998C12.265 15.9998 12.5193 15.8945 12.7068 15.707L17.7068 10.707C17.8466 10.5671 17.9418 10.389 17.9804 10.195C18.0189 10.0011 17.9991 9.80005 17.9235 9.61735C17.8478 9.43465 17.7197 9.27848 17.5552 9.1686C17.3908 9.05871 17.1975 9.00004 16.9998 9H6.99979Z"
        fill="white"
      />
    </svg>
  );
};

export default ArrowDown;
